import React from 'react';

import { UnauthenticatedSidebar } from '@/modules/common';

export const UnauthenticatedTemplate = ({ children }: { children: React.ReactNode }) => {
  return (
    <main className="relative flex min-h-screen w-screen max-w-full flex-1 overflow-hidden bg-background">
      <UnauthenticatedSidebar />
      <div className="flex min-h-full w-full">{children}</div>
    </main>
  );
};
